module.exports = __webpack_public_path__ + "img/icon_parkingService.d4483d47.png";